export default __webpack_public_path__ + "static/media/02_ice.91394902.webp";